module.exports = __webpack_public_path__ + "media/img/frontend_application/fast-enquiry-btn-icon-0803d72767b0dcc79e806b380112966c.png";